import { LoadableApp } from 'ui-seeker/core'

const NotFound = LoadableApp(import('./NotFound'))
const Login = LoadableApp(import('./Login'))
const Logout = LoadableApp(import('./Logout'))

const SessionRoutes = [
    {path: '/404', component: NotFound, onlyPage: true, needLogin: false},
    {path: '/login', component: Login, onlyPage: true, needLogin: false},
    {path: '/logout', component: Logout, onlyPage: true, needLogin: false}
]

export default SessionRoutes